import { render, staticRenderFns } from "./Visit-Timestamp.vue?vue&type=template&id=215a1658&"
import script from "./Visit-Timestamp.vue?vue&type=script&lang=js&"
export * from "./Visit-Timestamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports